import React from "react";
import { ArticleDetail } from "../types";
import AuthorInfo from "../authorInfo";
import { formatArticleDate, formatReadTime } from "../utils";

const ArticleHeading = ({ article }: { article: ArticleDetail }) => {
  const date = formatArticleDate(article.publishAt || article.createdAt);
  const readTime = formatReadTime(article.readTime);
  const subtitle = [date, readTime].filter(Boolean).join("  •  ");

  return (
    <section className="article-heading">
      <h1 className="article-title">{article.title}</h1>
      <AuthorInfo author={article.createdBy} subtitle={subtitle} />
    </section>
  );
};

export default ArticleHeading;
